import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShopifyProvider } from "./context/ShopifyContext";
import { CartProvider } from "./context/CartContext";
import CartDrawer from "./components/CartDrawer";
import CartNotification from "./components/CartNotification";
import HomePage from "./pages/HomePage";

function App() {
  return (
    <ShopifyProvider>
      <CartProvider>
        <BrowserRouter>
          <CartNotification />
          <CartDrawer />
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/* Cart checkout paths are handled by Netlify redirects to Shopify */}
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </ShopifyProvider>
  );
}

export default App;
